import { Component, EventEmitter, inject, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ApeDrawerComponent } from "../ape-drawer/ape-drawer.component";
import { TranslatePipe } from "../../pipe/translation.filter.pipe";
import { TRANSLATION_KEYS } from "../../constants/translations/translation-keys";
import { LoggerService } from "../../../ancestors/logger.service";
import { SvgIconComponent } from "angular-svg-icon";
import { UserDataService } from "src/app/services/data/user-data.service";

/**
 * Componente sidenav per la sezione supporto
 * Mostra contatti email e materiali informativi per l'utente
 */
@Component({
  selector: "ape-support-sidenav",
  standalone: true,
  imports: [
    CommonModule,
    ApeDrawerComponent,
    TranslatePipe,
    SvgIconComponent
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: "./ape-support-sidenav.component.html"
})
export class ApeSupportSidenavComponent {
  readonly TRANSLATION_KEYS = TRANSLATION_KEYS;

  private logger = inject(LoggerService);

  private userDataService = inject(UserDataService);

  /**
   * Visibilità del drawer
   */
  @Input() visible = false;

  /**
   * Evento di cambio visibilità
   */
  @Output() visibleChange = new EventEmitter<boolean>();

  constructor() {
    this.logger.setCaller(this.constructor.name);
  }

  /**
   * Gestisce il cambio di visibilità del drawer
   */
  onVisibleChange(visible: boolean): void {
    this.visible = visible;
    this.visibleChange.emit(visible);
  }

  /**
   * Verifica se l'utente corrente è un Manager
   */
  get isManager(): boolean {
    return this.userDataService?.isManager() ?? false;
  }

  /** URL materiale employee (Guide e materiali employee) */
  private readonly employeeMaterialUrl = "https://formazione.gruppomol.lcl/course/view.php?id=2765";

  /** URL materiale manager (Guide e materiali manager) */
  private readonly managerMaterialUrl = "https://formazione.gruppomol.lcl/course/view.php?id=2764";

  /**
   * Link materiali employee. Sezione visibile a tutti gli utenti.
   */
  get materialLinksSection1(): { label: string;
    url: string; }[] {
    return [
      {
        label: TRANSLATION_KEYS.support.MATERIAL_SECTION_LINK1_LABEL,
        url: this.employeeMaterialUrl
      }
    ];
  }

  /**
   * Link materiali manager. Sezione visibile solo agli utenti con abilitazione manager.
   */
  get materialLinksSection2(): { label: string;
    url: string; }[] {
    return [
      {
        label: TRANSLATION_KEYS.support.MATERIAL_SECTION_LINK2_LABEL,
        url: this.managerMaterialUrl
      }
    ];
  }

  /**
   * TrackBy per i link
   */
  trackByLinkUrl(index: number, link: {
    label: string;
    url: string;
  }): string {
    return link.url;
  }
}
